import {APP_INITIALIZER, Inject, NgModule} from "@angular/core";
import {IonicApp, IonicModule} from "ionic-angular";
import {MyApp} from "./app.component";
import {TranslateLoader, TranslateModule} from "ng2-translate";
import {InlineSVGModule} from "ng-inline-svg";
import {Http, HttpModule} from "@angular/http";
import {
    AuthModule,
    CombinedTranslateLoader,
    ConfigurationModule,
    DataClientVersion,
    ErrorModule,
    ErrorService,
    FedeltaHttpModule,
    I18nModule,
    I18nService,
    ImageService,
    LocalConfigurationService,
    provideEntityModel,
    provideSearchModel,
    ResourceModule,
    ServerLoggingService,
    ValidationModule,
    VersionService
} from "@fedelta-pos/data-client";
import {OrderingPageComponent} from "./ordering-page/ordering-page.component";
import {PaymentPageComponent} from "./payment/payment-page/payment-page.component";
import {NotificationService} from "./notification/notification.service";
import {QRCodeModule} from "angular2-qrcode";
import {EntryPageComponent} from "./start/entry-page/entry-page.component";
import {StoreMapPanelComponent} from "./store/store-map-panel/store-map-panel.component";
import {QrCodePanelComponent} from "./ui-elements/qr-code/qr-code-panel/qr-code-panel.component";
import {QrCodePageComponent} from "./ui-elements/qr-code/qr-code-page/qr-code-page.component";
import {
    OrderItemQuantityControlComponent
} from "./order/order-item/order-item-quantity-control/order-item-quantity-control.component";
import {DealsPageComponent} from "./deal/deals-page/deals-page.component";
import {OrderConfirmationPageComponent} from "./order/order-confirmation-page/order-confirmation-page.component";
import {LocationSearchPanelComponent} from "./ordering-context/location-search-panel/location-search-panel.component";
import {
    StripeManualPaymentCardPanelComponent
} from "./payment/card-payment/stripe-manual-payment-card-panel/stripe-manual-payment-card-panel.component";
import {ChangePasswordPageComponent} from "./identity/change-password-page/change-password-page.component";
import {ProfileEditPageComponent} from "./identity/profile-edit-page/profile-edit-page.component";
import {Geolocation} from "@ionic-native/geolocation";
import {AnalyticsService} from "./orchestration/analytics.service";
import {GeolocateService} from "./store/geolocate";
import {StatusBar} from "@ionic-native/status-bar";
import {SplashScreen} from "@ionic-native/splash-screen";
import {Device} from "@ionic-native/device";
import {SessionModel} from "./orchestration/session.model";
import {AppAvailability} from "@ionic-native/app-availability";
import {GroupByPipe} from "./html-utils/group-by.pipe";
import {CustomerOrdersPageComponent} from "./customer-info/customer-orders-page/customer-orders-page.component";
import {SaleReceiptPageComponent} from "./customer-info/sale-receipt-page/sale-receipt-page.component";
import {ReceiptComponent} from "./customer-info/receipt/receipt.component";
import {HtmlPipe} from "./html-utils/html.pipe";
import {DistancePipe} from "./store/distance.pipe";
import {BrowserModule} from "@angular/platform-browser";
import {OrderExtrasPanelComponent} from "./order/order-extras-panel/order-extras-panel.component";
import {FeedbackPageComponent} from "./customer-info/feedback-page/feedback-page.component";
import {NavigationService} from "./orchestration/navigation.service";
import {LogoComponent} from "./ui-elements/logo/logo.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ResponsiveService} from "./orchestration/responsive.service";
import {ResponsiveDirective} from "./orchestration/responsive.directive";
import {QuantityControlComponent} from "./inputs/quantity-control/quantity-control.component";
import {PromoCardComponent} from "./promo/promo-card/promo-card.component";
import {WebOrderingAppVersion} from "./config-support/version";
import {ImageCacheDirective} from "./ui-elements/image/image-cache.directive";
import {BackgroundImageDirective} from "./ui-elements/image/background-image.directive";
import {CachedImageService} from "./ui-elements/image/cached-image.service";
import {IdentityModel} from "./identity/identity.model";
import {SessionController} from "./orchestration/session.controller";
import {OrderItemEditPageComponent} from "./order/order-item/order-item-edit-page/order-item-edit-page.component";
import {
    OrderTypeSelectionPanelComponent
} from "./ordering-context/order-type-selection-panel/order-type-selection-panel.component";
import {StoreDetailsPanelComponent} from "./store/store-details-panel/store-details-panel.component";
import {MemberCardPanelComponent} from "./identity/member-card-panel/member-card-panel.component";
import {
    OrderingContextPanelComponent
} from "./ordering-context/ordering-context-panel/ordering-context-panel.component";
import {StoreDetailsPageComponent} from "./store/store-details-page/store-details-page.component";
import {OrderDetailsPanelComponent} from "./order/order-details-panel/order-details-panel.component";
import {CssVarDirective} from "./html-utils/css-var.directive";
import {CssVarPipe} from "./html-utils/css-var.pipe";
import {LoyaltyCardComponent} from "./loyalty-card/loyalty-card/loyalty-card.component";
import {TouchableDirective} from "./ui-elements/touchable.directive";
import {GlobalCssVarDirective} from "./html-utils/global-css-var.directive";
import {UrlPipe} from "./html-utils/url.pipe";
import {ButtonComponent} from "./buttons/button/button.component";
import {
    OrderTimeSelectionPageComponent
} from "./ordering-context/order-time-selection-page/order-time-selection-page.component";
import {StoreStatusPanelComponent} from "./store/store-status-panel/store-status-panel.component";
import {ExitPageComponent} from "./start/exit-page/exit-page.component";
import {OrderEditPanelComponent} from "./order/order-edit-panel/order-edit-panel.component";
import {
    DesktopHomePageLayoutComponent
} from "./page-layout/desktop-home-page-layout/desktop-home-page-layout.component";
import {OrderSummaryIconComponent} from "./order/order-summary-icon/order-summary-icon.component";
import {ApplePayButtonComponent} from "./buttons/apple-pay-button/apple-pay-button.component";
import {GooglePayButtonComponent} from "./buttons/google-pay-button/google-pay-button.component";
import {initParamConfigService, ParamConfigService} from "./config-support/param-config.service";
import {TicketComponent} from "./loyalty-card/ticket/ticket.component";
import {TipSelectionPageComponent} from "./payment/tip-selection-page/tip-selection-page.component";
import {TipSelectionPanelComponent} from "./payment/tip-selection-panel/tip-selection-panel.component";
import {InvoiceRequestPageComponent} from "./customer-info/invoice-request-page/invoice-request-page.component";
import {PhoneEditPageComponent} from "./customer-info/phone-edit-page/phone-edit-page.component";
import {CurrencyPipe} from "./string-utils/currency.pipe";
import {AgeVerificationPageComponent} from "./customer-info/age-verification-page/age-verification-page.component";
import {FeatureButtonPanelComponent} from "./ordering-page/feature-button-panel/feature-button-panel.component";
import {PromoCarouselComponent} from "./promo/promo-carousel/promo-carousel.component";
import {ReorderPageComponent} from "./ordering-page/reorder-page/reorder-page.component";
import {PromoPageComponent} from "./promo/promo-page/promo-page.component";
import {DietaryPanelComponent} from "./order/order-item/dietary-panel/dietary-panel.component";
import {CardScanService} from "./payment/card-payment/card-scan.service";
import {GroupOrderPageComponent} from "./group-order/group-order-page/group-order-page.component";
import {
    StripeScannedPaymentCardPanelComponent
} from "./payment/card-payment/stripe-scanned-payment-card-panel/stripe-scanned-payment-card-panel.component";
import {
    GroupOrderSummaryIconComponent
} from "./group-order/group-order-summary-icon/group-order-summary-icon.component";
import {NameEditPageComponent} from "./customer-info/name-edit-page/name-edit-page.component";
import {NativeWaiterAppService} from "./native-waiter-app.service";
import {PossessivePipe} from "./string-utils/possessive.pipe";
import {WOATimePipe} from "./string-utils/time.pipe";
import {LoadingSpinnerComponent} from "./ui-elements/loading/loading-spinner/loading-spinner.component";
import {LoadingService} from "./ui-elements/loading/loading.service";
import {MarketingEntryPageComponent} from "./customer-info/marketing-entry-page/marketing-entry-page.component";
import {NavMenuPageComponent} from "./nav-menu/nav-menu-page.component";
import {FullPageLayoutComponent} from "./page-layout/full-page-layout/full-page-layout.component";
import {ContentMessageComponent, FooterMessageComponent} from "./notification/message/message.component";
import {LoyaltyCardsPageComponent} from "./loyalty-card/loyalty-cards-page/loyalty-cards-page.component";
import {SpinnerComponent} from "./ui-elements/spinner/spinner.component";
import {ModalPageLayoutComponent} from "./page-layout/modal-page-layout/modal-page-layout.component";
import {CardBrandComponent} from "./ui-elements/card-brand/card-brand.component";
import {ChewzieLogoComponent} from "./ui-elements/chewzie-logo/chewzie-logo.component";
import {WatermarkComponent} from "./ui-elements/watermark/watermark.component";
import {PageFooterControlDirective} from "./page-layout/page-footer-control.directive";
import {IdentificationPageComponent} from "./identity/identification-page/identification-page.component";
import {PageContainerComponent} from "./orchestration/page-container/page-container.component";
import {SwipableDirective} from "./ui-elements/swipable.directive";
import {
    PageComponentContainerComponent
} from "./orchestration/page-container/page-component-container/page-component-container.component";
import {SimpleDialogPageComponent} from "./notification/simple-dialog-page/simple-dialog-page.component";
import {Type} from "@angular/core/src/type";
import {TrimPipe} from "./string-utils/trim.pipe";
import {LegalPanelComponent} from "./legal/legal-panel/legal-panel.component";
import {LegalPageComponent} from "./legal/legal-page/legal-page.component";
import {LinkComponent} from "./buttons/link/link.component";
import {ToggleComponent} from "./ui-elements/toggle/toggle.component";
import {OrderDetailsPageComponent} from "./order/order-details-page/order-details-page.component";
import {
    OrderItemExtraSizesEditPageComponent
} from "./order/order-item/order-item-options-panel/order-item-extra-sizes-edit-page/order-item-extra-sizes-edit-page.component";
import {
    OrderItemCombinedExtrasEditPageComponent
} from "./order/order-item/order-item-options-panel/order-item-combined-extras-edit-page/order-item-combined-extras-edit-page.component";
import {
    OrderItemPlgEditPageComponent
} from "./order/order-item/order-item-options-panel/order-item-plg-edit-page/order-item-plg-edit-page.component";
import {
    OrderItemExtrasEditPanelComponent
} from "./order/order-item/order-item-options-panel/order-item-extras-edit-panel/order-item-extras-edit-panel.component";
import {
    OrderItemOptionsPanelComponent
} from "./order/order-item/order-item-options-panel/order-item-options-panel.component";
import {DealCodeEntryPageComponent} from "./deal/deal-code-entry-page/deal-code-entry-page.component";
import {StickyDirective} from "./ui-elements/sticky.directive";
import {
    OrderItemOptionControlComponent
} from "./order/order-item/order-item-options-panel/order-item-option-control/order-item-option-control.component";
import {FooterMessagesComponent} from "./notification/footer-messages/footer-messages.component";
import {IconButtonComponent} from "./buttons/icon-button/icon-button.component";
import {SelectorControlComponent} from "./inputs/selector-control/selector-control.component";
import {IconLibraryComponent} from "./ui-elements/icon-library/icon-library.component";
import {IconComponent} from "./ui-elements/icon/icon.component";
import {DealSummaryIconComponent} from "./deal/deal-summary-icon/deal-summary-icon.component";
import {ElementWidthDirective} from "./html-utils/element-width.directive";
import {PageHeaderImageComponent} from "./page-layout/page-header-image/page-header-image.component";
import {
    OrderingContextSelectionPageComponent
} from "./ordering-context/ordering-context-selection-page/ordering-context-selection-page.component";
import {PromoModel} from "./promo/promo.model";
import {GroupOrderModel} from "./group-order/group-order.model";
import {MenuModel} from "./menu/menu.model";
import {DealModel} from "./deal/deal.model";
import {OrderModel} from "./order/order.model";
import {
    OrderingContextModel,
    OrderingContextStoreSearchFilterProvider
} from "./ordering-context/ordering-context.model";
import {PaymentModel} from "./payment/payment.model";
import {
    OrderingContextEditPageComponent
} from "./ordering-context/ordering-context-edit-page/ordering-context-edit-page.component";
import {SelectionFieldComponent} from "./inputs/selection-field/selection-field.component";
import {OrderErrorsPanelComponent} from "./order/order-errors-panel/order-errors-panel.component";
import {OrderTotalsPanelComponent} from "./order/order-totals-panel/order-totals-panel.component";
import {OrderHeadingPanelComponent} from "./ordering-page/order-heading-panel/order-heading-panel.component";
import {
    CustomerNotesEditPageComponent
} from "./ordering-context/customer-notes-edit-page/customer-notes-edit-page.component";
import {FieldComponent} from "./inputs/field/field.component";
import {FormComponent} from "./inputs/form/form.component";
import {TextFieldComponent} from "./inputs/text-field/text-field.component";
import {FormsModule} from "@angular/forms";
import {PhoneNumberFieldComponent} from "./inputs/phone-number-field/phone-number-field.component";
import {SmsPhoneNumberDirective} from "./inputs/phone-number-field/sms-phone-number.directive";
import {TextAreaFieldComponent} from "./inputs/text-area-field/text-area-field.component";
import {EmailDirective} from "./inputs/email-field/email.directive";
import {OptionComponent} from "./inputs/selection-field/option.component";
import {OptionsPageComponent} from "./inputs/selection-field/options-page/options-page.component";
import {PasswordFieldComponent} from "./inputs/password-field/password-field.component";
import {EmailFieldComponent} from "./inputs/email-field/email-field.component";
import {PhoneNumberDirective} from "./inputs/phone-number-field/phone-number.directive";
import {DateFieldComponent} from "./inputs/date-field/date-field.component";
import {FieldPairComponent} from "./inputs/form/field-pair/field-pair.component";
import {DecimalFieldComponent} from "./inputs/decimal-field/decimal-field.component";
import {FieldGroupComponent} from "./inputs/form/field-group/field-group.component";
import {RadioFieldComponent} from "./inputs/radio-field/radio-field.component";
import {ThemeModel} from "./theme/theme.model";
import {QuickPayPanelComponent} from "./ordering-page/quick-pay-panel/quick-pay-panel.component";
import {MenuItemPanelComponent} from "./menu/menu-item-panel/menu-item-panel.component";
import {
    MenuCategorySelectionPanelComponent
} from "./menu/menu-category-selection-panel/menu-category-selection-panel.component";
import {MenuItemSelectionPanelComponent} from "./menu/menu-item-selection-panel/menu-item-selection-panel.component";
import {
    MenuSubcategoryAnchorPanelComponent
} from "./menu/menu-subcategory-anchor-panel/menu-subcategory-anchor-panel.component";
import {MenuSearchPageComponent} from "./menu/menu-search-page/menu-search-page.component";
import {MemberSummaryEntityModel} from "./identity/member-summary-entity.model";
import {BeaconSearchModel} from "./beacon/beacon-search.model";
import {LoyaltyCardRedemptionService} from "./loyalty-card/loyalty-card-redemption.service";
import {AppEntityModel} from "./orchestration/app-entity.model";
import {AppEntryNotificationService} from "./orchestration/app-entry-notification.service";
import {
    IntegratedDeliveryAddressValidationService
} from "./ordering-context/integrated-delivery-address-validation.service";
import {ActiveEntitlementValidationService} from "./deal/active-entitlement-validation.service";
import {PendingOrdersService} from "./order/pending-orders.service";
import {
    TyroManualPaymentCardPanelComponent
} from "./payment/card-payment/tyro-manual-payment-card-panel/tyro-manual-payment-card-panel.component";
import {CustomerDetailsService} from "./customer-info/customer-details.service";
import {OrderPaymentDetailsEntityModel} from "./payment/order-payment-details-entity.model";
import {ActiveSchedulesSearchModel} from "./schedule/active-schedules-search.model";
import {AppSessionService} from "./orchestration/app-session.service";
import {AvailableOrderTimesService} from "./order/available-order-times.service";
import {AppUserService} from "./identity/app-user.service";
import {OrderPostscriptService} from "./order/order-postscript.service";
import {EntitlementEntityModel} from "./deal/entitlement-entity.model";
import {OrderInitiationService} from "./order/order-initiation.service";
import {OrderPlacementService} from "./order/order-placement.service";
import {OrderPlacementStatusService} from "./order/order-placement-status.service";
import {RecentOrderService} from "./order/recent-order.service";
import {STORE_SEARCH_FILTER_PROVIDER, StoreSearchModel} from "./store/store-search.model";
import {OrderTransferRequestPollService} from "./group-order/order-transfer-request-poll.service";
import {OrderTransferService} from "./group-order/order-transfer.service";
import {OrderTransferTargetEntityModel} from "./group-order/order-transfer-target-entity.model";
import {OrderTransferTargetSearchModel} from "./group-order/order-transfer-target-search.model";
import {WalletPaymentPageComponent} from "./payment/wallet-payment/wallet-payment-page/wallet-payment-page.component";
import {CustomerDetailsPanelComponent} from "./customer-info/customer-details-panel/customer-details-panel.component";
import {SellableSizesSearchModel} from "./menu/sellable-sizes-search.model";
import {
    AdyenManualPaymentCardPanelComponent
} from "./payment/card-payment/adyen-manual-payment-card-panel/adyen-manual-payment-card-panel.component";
import {Adyen3dsPageComponent} from "./payment/adyen-3ds-page/adyen-3ds-page.component";
import {MenuEntityModel} from "./menu/menu-entity.model";

export function translateLoaderFactory(i18nService: I18nService, http: Http) {
    return new CombinedTranslateLoader(i18nService, http, "assets/i18n");
}

export const entryComponents: Type<any>[] = [
    Adyen3dsPageComponent,
    AgeVerificationPageComponent,
    ChangePasswordPageComponent,
    CustomerNotesEditPageComponent,
    CustomerOrdersPageComponent,
    DealCodeEntryPageComponent,
    DealsPageComponent,
    EntryPageComponent,
    ExitPageComponent,
    FeedbackPageComponent,
    IdentificationPageComponent,
    InvoiceRequestPageComponent,
    LegalPageComponent,
    LoyaltyCardsPageComponent,
    MarketingEntryPageComponent,
    ProfileEditPageComponent,
    MenuSearchPageComponent,
    MyApp,
    NameEditPageComponent,
    NavMenuPageComponent,
    OptionsPageComponent,
    OrderConfirmationPageComponent,
    OrderDetailsPageComponent,
    OrderingPageComponent,
    OrderItemCombinedExtrasEditPageComponent,
    OrderItemEditPageComponent,
    OrderItemExtraSizesEditPageComponent,
    OrderItemPlgEditPageComponent,
    OrderTimeSelectionPageComponent,
    OrderingContextEditPageComponent,
    OrderingContextSelectionPageComponent,
    PageComponentContainerComponent,
    PaymentPageComponent,
    PhoneEditPageComponent,
    PromoPageComponent,
    QrCodePageComponent,
    ReorderPageComponent,
    SaleReceiptPageComponent,
    GroupOrderPageComponent,
    SimpleDialogPageComponent,
    StoreDetailsPageComponent,
    TipSelectionPageComponent,
    WalletPaymentPageComponent
];

@NgModule({
    declarations: [
        Adyen3dsPageComponent,
        AdyenManualPaymentCardPanelComponent,
        AgeVerificationPageComponent,
        ApplePayButtonComponent,
        BackgroundImageDirective,
        ButtonComponent,
        CardBrandComponent,
        ChangePasswordPageComponent,
        ChewzieLogoComponent,
        ContentMessageComponent,
        CssVarDirective,
        CssVarPipe,
        CurrencyPipe,
        CustomerDetailsPanelComponent,
        CustomerNotesEditPageComponent,
        CustomerOrdersPageComponent,
        DateFieldComponent,
        DealCodeEntryPageComponent,
        DealSummaryIconComponent,
        DealsPageComponent,
        DecimalFieldComponent,
        DesktopHomePageLayoutComponent,
        DietaryPanelComponent,
        DistancePipe,
        ElementWidthDirective,
        EmailDirective,
        EmailFieldComponent,
        EntryPageComponent,
        ExitPageComponent,
        FeatureButtonPanelComponent,
        FeedbackPageComponent,
        FieldComponent,
        FieldGroupComponent,
        FieldPairComponent,
        FooterMessageComponent,
        FooterMessagesComponent,
        FormComponent,
        FullPageLayoutComponent,
        GlobalCssVarDirective,
        GooglePayButtonComponent,
        GroupByPipe,
        HtmlPipe,
        IconButtonComponent,
        IconComponent,
        IconLibraryComponent,
        IdentificationPageComponent,
        ImageCacheDirective,
        QuantityControlComponent,
        InvoiceRequestPageComponent,
        LegalPageComponent,
        LegalPanelComponent,
        LinkComponent,
        LoadingSpinnerComponent,
        LocationSearchPanelComponent,
        LogoComponent,
        LoyaltyCardComponent,
        LoyaltyCardsPageComponent,
        MarketingEntryPageComponent,
        MemberCardPanelComponent,
        ProfileEditPageComponent,
        MenuCategorySelectionPanelComponent,
        MenuItemPanelComponent,
        MenuItemSelectionPanelComponent,
        MenuSearchPageComponent,
        MenuSubcategoryAnchorPanelComponent,
        ModalPageLayoutComponent,
        MyApp,
        NameEditPageComponent,
        NavMenuPageComponent,
        OptionComponent,
        OptionsPageComponent,
        OrderConfirmationPageComponent,
        OrderDetailsPageComponent,
        OrderDetailsPanelComponent,
        OrderEditPanelComponent,
        OrderErrorsPanelComponent,
        OrderExtrasPanelComponent,
        OrderHeadingPanelComponent,
        OrderingPageComponent,
        OrderItemCombinedExtrasEditPageComponent,
        OrderItemEditPageComponent,
        OrderItemExtraSizesEditPageComponent,
        OrderItemExtrasEditPanelComponent,
        OrderItemOptionControlComponent,
        OrderItemOptionsPanelComponent,
        OrderItemPlgEditPageComponent,
        OrderItemQuantityControlComponent,
        OrderSummaryIconComponent,
        OrderTimeSelectionPageComponent,
        OrderTotalsPanelComponent,
        OrderTypeSelectionPanelComponent,
        OrderingContextEditPageComponent,
        OrderingContextPanelComponent,
        OrderingContextSelectionPageComponent,
        PageComponentContainerComponent,
        PageContainerComponent,
        PageFooterControlDirective,
        PageHeaderImageComponent,
        PasswordFieldComponent,
        StripeManualPaymentCardPanelComponent,
        StripeScannedPaymentCardPanelComponent,
        PaymentPageComponent,
        PhoneEditPageComponent,
        PhoneNumberDirective,
        PhoneNumberFieldComponent,
        PossessivePipe,
        PromoCardComponent,
        PromoCarouselComponent,
        PromoPageComponent,
        QrCodePageComponent,
        QrCodePanelComponent,
        QuickPayPanelComponent,
        RadioFieldComponent,
        ReceiptComponent,
        ReorderPageComponent,
        ResponsiveDirective,
        SaleReceiptPageComponent,
        SelectionFieldComponent,
        SelectorControlComponent,
        GroupOrderPageComponent,
        GroupOrderSummaryIconComponent,
        SimpleDialogPageComponent,
        SmsPhoneNumberDirective,
        SpinnerComponent,
        StickyDirective,
        StoreDetailsPageComponent,
        StoreDetailsPanelComponent,
        StoreMapPanelComponent,
        StoreStatusPanelComponent,
        SwipableDirective,
        TextAreaFieldComponent,
        TextFieldComponent,
        TicketComponent,
        TipSelectionPageComponent,
        TipSelectionPanelComponent,
        ToggleComponent,
        TouchableDirective,
        TrimPipe,
        TyroManualPaymentCardPanelComponent,
        UrlPipe,
        WOATimePipe,
        WalletPaymentPageComponent,
        WatermarkComponent
    ],
    entryComponents: entryComponents,
    imports: [
        HttpModule,
        FormsModule,
        InlineSVGModule,
        QRCodeModule,
        BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: translateLoaderFactory,
            deps: [I18nService, Http]
        }),
        AuthModule.forRoot({
            httpTimeout: 10000
        }),
        FedeltaHttpModule.forRoot({
            httpTimeout: 20000
        }),
        ConfigurationModule.forRoot({
            application: "woa",
            localConfigFile: "assets/appconfig.json",
            contextNames: ["userId", "webTerminalId", "outletId", "application"]
        }),
        ErrorModule.forRoot(),
        ValidationModule.forRoot({
            application: "woa"
        }),
        I18nModule.forRoot(),
        IonicModule.forRoot(MyApp, {
            animate: false
        }, 
{
  links: [
    
  ]
}),
        ResourceModule.forRoot({
            nameSpace: "wo",
            entityNames: [
                "app",
                "identity",
                "menu",
                "device-token",
                "entitlement",
                "member-summary",
                "web-order-payment-details",
                "order-transfer-target"
            ],
            searchNames: [
                "identity",
                "member-sales",
                "sellable-sizes",
                "store",
                "beacon",
                "active-schedules",
                "order-transfer-target"
            ],
            actionNames: [
                "active-entitlement-validation",
                "app-entry-notification",
                "app-feedback",
                "identity-change-password",
                "identity-request-password-reset",
                "identity-reset-password",
                "available-order-times",
                "loyalty-card-redeem",
                "integrated-delivery-address-validation",
                "invoice-email-request",
                "web-order-initiation",
                "web-order-transfer",
                "web-order-transfer-request-poll",
                "web-order-placement-status",
                "web-order-placement",
                "web-order-postscript",
                "web-pending-orders"
            ]
        })
    ],
    bootstrap: [IonicApp],
    providers: [
        {provide: STORE_SEARCH_FILTER_PROVIDER, useClass: OrderingContextStoreSearchFilterProvider},
        provideEntityModel(AppEntityModel),
        provideEntityModel(EntitlementEntityModel),
        provideEntityModel(MemberSummaryEntityModel),
        provideEntityModel(MenuEntityModel),
        provideEntityModel(OrderPaymentDetailsEntityModel),
        provideEntityModel(OrderTransferTargetEntityModel),
        provideSearchModel(ActiveSchedulesSearchModel),
        provideSearchModel(BeaconSearchModel),
        provideSearchModel(OrderTransferTargetSearchModel),
        provideSearchModel(SellableSizesSearchModel),
        provideSearchModel(StoreSearchModel),
        ActiveEntitlementValidationService,
        AnalyticsService,
        AppAvailability,
        AppEntryNotificationService,
        AppSessionService,
        AppUserService,
        AvailableOrderTimesService,
        CachedImageService,
        CardScanService,
        CustomerDetailsService,
        DealModel,
        Device,
        ErrorService,
        GeolocateService,
        Geolocation,
        IdentityModel,
        ImageService,
        IntegratedDeliveryAddressValidationService,
        LoadingService,
        LoyaltyCardRedemptionService,
        MenuModel,
        NativeWaiterAppService,
        NavigationService,
        NotificationService,
        OrderInitiationService,
        OrderModel,
        OrderPlacementService,
        OrderPlacementStatusService,
        OrderPostscriptService,
        OrderTransferRequestPollService,
        OrderTransferService,
        OrderingContextModel,
        ParamConfigService,
        PaymentModel,
        PendingOrdersService,
        PromoModel,
        RecentOrderService,
        ResponsiveService,
        ServerLoggingService,
        SessionController,
        SessionModel,
        GroupOrderModel,
        SplashScreen,
        StatusBar,
        ThemeModel,
        VersionService,
        {
            provide: APP_INITIALIZER,
            useFactory: initParamConfigService,
            multi: true,
            deps: [ParamConfigService]
        },
        DataClientVersion,
        WebOrderingAppVersion
    ]
})

export class AppModule {
    constructor(configurationService: LocalConfigurationService,
                paramConfigService: ParamConfigService,
                navigationService: NavigationService,
                analyticsService: AnalyticsService,
                sessionModel: SessionModel,
                orderModel: OrderModel,
                groupOrderModel: GroupOrderModel,
                menuModel: MenuModel,
                paymentModel: PaymentModel,
                promoModel: PromoModel,
                dealModel: DealModel,
                identityModel: IdentityModel,
                orderingContextModel: OrderingContextModel,
                sessionController: SessionController,
                @Inject(STORE_SEARCH_FILTER_PROVIDER) storeSearchFilterProvider: OrderingContextStoreSearchFilterProvider) {
        console.log("--- AppModule");

        const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
        if (urlParams.get("localConfigFile")) {
            configurationService["localConfigFile"] = "assets/" + urlParams.get("localConfigFile");
            configurationService["localConfigurationsObservable"] = undefined;
        }
        console.log("pathname = " + window.location.pathname);

        navigationService.registerComponents(entryComponents);

        // Avoid circular injection dependencies between models
        paramConfigService.identityModel = identityModel;

        analyticsService.sessionModel = sessionModel;
        analyticsService.orderModel = orderModel;
        analyticsService.paymentModel = paymentModel;
        analyticsService.orderingContextModel = orderingContextModel;

        menuModel.orderModel = orderModel;

        paymentModel.orderModel = orderModel;

        promoModel.orderModel = orderModel;
        promoModel.menuModel = menuModel;

        dealModel.orderModel = orderModel;

        identityModel.menuModel = menuModel;
        identityModel.sessionController = sessionController;

        navigationService.sessionController = sessionController;

        orderingContextModel.orderModel = orderModel;
        orderingContextModel.menuModel = menuModel;
        orderingContextModel.dealModel = dealModel;
        orderingContextModel.identityModel = identityModel;

        orderModel.groupOrderModel = groupOrderModel;

        storeSearchFilterProvider.orderingContextModel = orderingContextModel;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts